// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"54aff0d0","513":"961235d4","539":"036d13e5","736":"f770df73","787":"98fb7e2d"}[chunkId] + ".chunk.js";
};